/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

enum ChunkedStreamPlaybackMode {
    Live = 1,
    OndDemand = 2
}

export default ChunkedStreamPlaybackMode;